<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title>
        <v-btn text small :to="{ name: 'Exemptions' }">
          <v-icon left> mdi-arrow-left </v-icon>
          Back
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          outlined
          class="mx-2"
          @click="downloadLink(proforma)"
        >
          <v-icon left> mdi-download </v-icon>
          Download
        </v-btn>
        <v-btn color="primary" @click="pay">
          <v-icon left> mdi-send </v-icon>
          Pay KES
          {{ parseFloat(amountToPay.replace(/,/g, "")) | currencyFormat }}
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row>
          <v-col cols="8" offset="2">
            <v-card-text class="elevation-1 my-1">
              <pdf style="width: 100%" :src="proforma" />
            </v-card-text>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import FileMixin from "@brainspore/celadon-base/mixin/FileMixin";
import pdf from "vue-pdf";
import { AuthService } from "@/packages/dashboard/modules/auth";
export default {
  name: "ExemptionPayments",
  components: { pdf },
  mixins: [FileMixin],
  data: function () {
    return {};
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      if (to.params.code) {
        v.$store.dispatch("Exemption/getExemption", to.params.code);
        window.document.title = "KISEB::Pay For Exemptions";
      }
    });
  },
  computed: {
    exemption() {
      return this.$store.getters["Exemption/exemptionGetter"]("exemption");
    },
    proforma() {
      return this.$store.getters["Exemption/exemptionGetter"]("proforma");
    },
    user() {
      return AuthService.user;
    },
    amountToPay() {
      return this.$store.getters["Dashboard/amountToPay"];
    },
  },
  methods: {
    pay: function () {
      const PhoneNo =
        this.user.profile.phoneNo.charAt(0) === "+"
          ? this.user.profile.phoneNo.slice(1)
          : this.user.profile.phoneNo.charAt(0) === "0"
            ? `254${this.user.profile.phoneNo.slice(1)}`
            : this.user.profile.phoneNo;
      const data = this.exemption;
      this.$confirm.show({
        title: "Exemption Payment",
        rejectLabel: "Pay Later",
        text: `Application Payment for Exemption No. ${data.no}`,
        onConfirm: () => {
          let payload = {
            payerID: data.profileID,
            sourceDocumentNo: data.no,
            serviceID: data.serviceCode,
            description: "Exemption Payment",
            amount: parseFloat(this.amountToPay.replace(/,/g, "")).toString(),
            accountNo: PhoneNo,
            email: this.user.profile.email,
            idNumber: this.user.profile.identificationDocumentNo,
            name: `${this.user.profile.firstName} ${this.user.profile.lastName}`,
            success_url: `${process.env.VUE_APP_URL}${
              this.$router.resolve({ name: "Exemptions" }).href
            }`,
            fail_url: window.location.href,
          };

          payload = btoa(JSON.stringify(payload));
          // window.open(
          //   `${process.env.VUE_APP_PAYGATE_CHECKOUT_URL}/?payload=${payload}`,
          //   "_blank"
          // );
          this.$checkout.pay(payload);
        },
        onCancel: () => {
          Event.$emit("ApiInfo", "Payment cancelled");
          this.$router.replace({ name: "Exemptions" });
          this.$store.dispatch("Exemption/exemptions");
        },
      });
    },
  },
  watch: {
    exemption: function (val) {
      if (val) {
        this.$store.dispatch("Dashboard/getStudentAmountToPay", {
          profileNo: val.profileID,
          amount: val.amount,
        });
      }
    },
  },
};
</script>

<style scoped></style>
